import { render, staticRenderFns } from "./manageDiffer.vue?vue&type=template&id=43131484&scoped=true&"
import script from "./manageDiffer.vue?vue&type=script&lang=js&"
export * from "./manageDiffer.vue?vue&type=script&lang=js&"
import style0 from "./manageDiffer.vue?vue&type=style&index=0&id=43131484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43131484",
  null
  
)

export default component.exports